type Token = {
  name: string
  address: string,
}

export const TOKEN_LIST: Token[] = [{
  name: 'Tether USD',
  address: '0xdAC17F958D2ee523a2206206994597C13D831ec7'
}, {
  name: 'USD Coin',
  address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
}, {
  name: 'BNB',
  address: '0xB8c77482e45F1F44dE1745F52C74426C631bDD52'
}, {
  name: 'Binance USD',
  address: '0x4fabb145d64652a948d72533023f6e7a623c7c53'
}, {
  name: 'stETH',
  address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84'
}, {
  name: 'Uniswap',
  address: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984'
}]
